import Immutable from 'immutable';

const initialChatterState = Immutable.Map({
    id: null,
    hasSentFirstMessage: false
});

const chatter = (state = initialChatterState, action) => {
    switch (action.type) {
        case 'SET_CHATTER':
            return state.set("id", action.chatter);
        case 'HAS_SENT_FIRST_MESSAGE':
        	return state.set('hasSentFirstMessage', true);
        default:
            return state;
    }
}

export default chatter;


// WEBPACK FOOTER //
// ./src/reducers/chatter.js